import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSORTATIONORDERSTableStructure";
export const UPDATE_TABLE_DATA = "updateSORTATIONORDERSTableData";
// export const EXPORT_TABLE_DATA = "exportSORTATIONORDERSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSORTATIONORDERSTableStructure";
export const SET_TABLE_DATA = "setSORTATIONORDERSTableData";
export const SET_TABLE_FILTER = "setSORTATIONORDERSTableFilter";
export const SET_TABLE_PAGE = "setSORTATIONORDERSTablePage";
export const SET_TABLE_PERPAGE = "setSORTATIONORDERSTablePerPage";
export const SET_TABLE_SORTBY = "setSORTATIONORDERSTableSortBy";
export const SET_TABLE_SORTORDER = "setSORTATIONORDERSTableSortOrder";
// export const SET_EXPORT_LINK = "setSORTATIONORDERSExportLink";

const state = {
  // export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getSORTATIONORDERSTableProperties(state) {
    return state.table_structure.properties;
  },
  getSORTATIONORDERSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSORTATIONORDERSTableState(state) {
    return state.table_state;
  },

  getSORTATIONORDERSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSORTATIONORDERSTableFilters(state) {
    return state.table_structure.filters;
  },

  getSORTATIONORDERSTableData(state) {
    return state.table_data.data;
  },

  // getSORTATIONORDERSExportUrl(state) {
  //   return state.export_link;
  // },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/sortation_orders")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/sortation_orders/datatable", {
        ...payload,
        warehouse_id: context.getters.getSelectedWarehouse,
      })
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  // [EXPORT_TABLE_DATA](context, payload) {
  //   context.commit(SET_PAGE_LOADING, true);
  //   return new Promise((resolve) => {
  //     ApiService.post("/warehouse_management/sortation_orders/export", payload)
  //       .then(({ data }) => {
  //         context.commit(SET_EXPORT_LINK, data.url);
  //         resolve(data);
  //       })
  //       .catch((data) => {
  //         context.commit(SET_PAGE_LOADING, false);
  //         resolve(data);
  //       });
  //   });
  // },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  // [SET_EXPORT_LINK](state, link) {
  //   state.export_link = link;
  // },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
